import { IWorkOrderAdapter } from './IWorkOrderAdapter';
import { ApiResponse } from '../../types/api';
import { WorkOrder, CreateWorkOrderDto, WorkOrderFilter } from '../../types/workOrder';
import { ApiClient } from '../apiClient';
import { hasApiEndpoint } from '../../config/backend';

const MOCK_WORK_ORDERS: WorkOrder[] = [
  {
    work_order_id: 'WO-2026-00045',
    complaint_id: 'CMP-2026-00101',
    complaint_title: 'AC Cooling Failure in Server Room 101',
    vendor_id: 'VND-001',
    vendor_name: 'CoolTech HVAC Solutions',
    supervisor_name: 'Supervisor Suresh',
    technician_name: 'Tech John Doe',
    work_category_name: 'Air Conditioning & HVAC',
    description: 'Compressor E4 fault repair & refrigerant recharge',
    scope_of_work: 'Diagnose compressor E4 circuit board error, replace faulty capacitor, pressure test refrigerant lines, and recharge R410A gas.',
    estimated_cost: 450.00,
    start_date: '2026-09-12T11:00:00Z',
    target_date: '2026-09-12T16:00:00Z',
    status: 'In Progress',
    created_at: '2026-09-12T10:30:00Z',
    attachment_urls: [],
  },
  {
    work_order_id: 'WO-2026-00046',
    complaint_id: 'CMP-2026-00102',
    complaint_title: 'Main Pipe Leakage in Washroom Block B',
    vendor_id: 'VND-002',
    vendor_name: 'Alpha Plumbing & Piping',
    supervisor_name: 'Supervisor Suresh',
    work_category_name: 'Plumbing & Drainage',
    description: 'Replace cracked 2-inch PVC junction pipe under sink',
    scope_of_work: 'Isolate main valve, replace PVC elbow junction, install new seal ring, and test line under 5 bar pressure.',
    estimated_cost: 180.00,
    target_date: '2026-09-13T12:00:00Z',
    status: 'Assigned',
    created_at: '2026-09-12T11:45:00Z',
    attachment_urls: [],
  },
];

export class GASWorkOrderAdapter implements IWorkOrderAdapter {
  private woStore: WorkOrder[] = [...MOCK_WORK_ORDERS];

  async getWorkOrders(filter?: WorkOrderFilter): Promise<ApiResponse<WorkOrder[]>> {
    if (!hasApiEndpoint()) {
      let data = [...this.woStore];
      if (filter?.status && filter.status !== 'ALL') {
        data = data.filter(w => w.status.toUpperCase() === filter.status?.toUpperCase());
      }
      if (filter?.complaint_id) {
        data = data.filter(w => w.complaint_id === filter.complaint_id);
      }
      if (filter?.search) {
        const q = filter.search.toLowerCase();
        data = data.filter(w => w.work_order_id.toLowerCase().includes(q) || w.description.toLowerCase().includes(q));
      }
      return { success: true, data, message: 'Loaded Work Orders' };
    }
    return ApiClient.get<WorkOrder[]>('/work-orders');
  }

  async getWorkOrderById(id: string): Promise<ApiResponse<WorkOrder>> {
    if (!hasApiEndpoint()) {
      const wo = this.woStore.find(w => w.work_order_id === id) || this.woStore[0];
      return { success: true, data: wo, message: 'Work Order Loaded' };
    }
    return ApiClient.get<WorkOrder>(`/work-orders/${id}`);
  }

  async createWorkOrder(dto: CreateWorkOrderDto): Promise<ApiResponse<WorkOrder>> {
    if (!hasApiEndpoint()) {
      const newWo: WorkOrder = {
        work_order_id: `WO-2026-000${this.woStore.length + 47}`,
        complaint_id: dto.complaint_id,
        complaint_title: 'Facility Maintenance Complaint',
        work_category_name: dto.work_category_name,
        vendor_name: dto.vendor_name || 'CoolTech HVAC Solutions',
        supervisor_name: dto.supervisor_name || 'Supervisor Suresh',
        description: dto.description,
        scope_of_work: dto.scope_of_work,
        estimated_cost: dto.estimated_cost,
        target_date: dto.target_date,
        status: 'Assigned',
        created_at: new Date().toISOString(),
        attachment_urls: [],
      };
      this.woStore.unshift(newWo);
      return { success: true, data: newWo, message: 'Work Order Created' };
    }
    return ApiClient.post<WorkOrder>('/work-orders', dto);
  }

  async updateStatus(id: string, status: WorkOrder['status']): Promise<ApiResponse<WorkOrder>> {
    if (!hasApiEndpoint()) {
      const wo = this.woStore.find(w => w.work_order_id === id);
      if (wo) wo.status = status;
      return { success: true, data: wo!, message: 'Work Order Status Updated' };
    }
    return ApiClient.post<WorkOrder>(`/work-orders/${id}/status`, { status });
  }
}
